import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'moment/locale/es-mx';
import * as moment from 'moment';

import { AppModule } from './app/app.module';

// Configurar moment con locale español mexicano
moment.locale('es-mx');

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error(err));
